// dashboardActions.ts
import type Dashboard from '@src/Objects/Dashboard';
import type { Action } from 'redux';

export enum EDashboardAction {
    SET_DASHBOARDS = 'SET_DASHBOARDS',
    UPDATE_DASHBOARD = 'UPDATE_DASHBOARD',
    DELETE_DASHBOARD = 'DELETE_DASHBOARD',
}

interface SetDashboardsAction extends Action {
    type: EDashboardAction.SET_DASHBOARDS;
    payload: Dashboard[];
}
interface UpdateDashboardAction extends Action {
    type: EDashboardAction.UPDATE_DASHBOARD;
    payload: Dashboard;
}
interface DeleteDashboardAction extends Action {
    type: EDashboardAction.DELETE_DASHBOARD;
    payload: string; // id als string
}

export type DashboardAction = SetDashboardsAction | UpdateDashboardAction | DeleteDashboardAction;

export const setDashboards = (dashboards: Dashboard[]): SetDashboardsAction => ({
    type: EDashboardAction.SET_DASHBOARDS,
    payload: dashboards,
});
export const updateDashboard = (dashboard: Dashboard): UpdateDashboardAction => ({
    type: EDashboardAction.UPDATE_DASHBOARD,
    payload: dashboard,
});
export const deleteDashboard = (id: string): DeleteDashboardAction => ({
    type: EDashboardAction.DELETE_DASHBOARD,
    payload: id,
});

const initialState: Dashboard[] = [];

export const dashboardReducer = (state = initialState, action: DashboardAction): Dashboard[] => {
    switch (action.type) {
        case EDashboardAction.SET_DASHBOARDS:
            return action.payload;

        case EDashboardAction.UPDATE_DASHBOARD: {
            const idx = state.findIndex((d) => d.id === action.payload.id);
            if (idx !== -1) {
                const copy = [...state];
                copy[idx] = action.payload;
                return copy;
            }
            return [...state, action.payload];
        }

        case EDashboardAction.DELETE_DASHBOARD:
            return state.filter((d) => d.id !== action.payload);

        default:
            return state;
    }
};
